import { useCallback, useRef, useState } from "react";
import { analyzeAudioQuality } from "../utils/audioQuality/analyzeAudioQuality";
import { MIN_SPINNER_MS } from "../utils/audioQuality/constants";

function useQualityCheck() {
  const [result, setResult] = useState(null);
  const [isChecking, setIsChecking] = useState(false);
  const runIdRef = useRef(0);

  const reset = useCallback(() => {
    runIdRef.current += 1;
    setResult(null);
    setIsChecking(false);
  }, []);

  const runQualityCheck = useCallback(async (blob) => {
    const runId = runIdRef.current + 1;
    runIdRef.current = runId;
    setIsChecking(true);
    setResult(null);

    const startedAt = Date.now();

    try {
      const analysisResult = await analyzeAudioQuality(blob);
      const elapsed = Date.now() - startedAt;
      const remaining = Math.max(0, MIN_SPINNER_MS - elapsed);

      if (remaining > 0) {
        await new Promise((resolve) => {
          setTimeout(resolve, remaining);
        });
      }

      if (runIdRef.current === runId) {
        setResult(analysisResult);
      }

      return analysisResult;
    } finally {
      if (runIdRef.current === runId) {
        setIsChecking(false);
      }
    }
  }, []);

  return {
    result,
    audioQualityPassed: result?.passed ?? null,
    isChecking,
    runQualityCheck,
    reset,
  };
}

export default useQualityCheck;
